var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeMartin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33948 10.6616H5.33904C2.39037 10.6616 0 13.0519 0 16.0006V16.001C0 18.9496 2.39037 21.3399 5.33904 21.3399H5.33948C8.28815 21.3399 10.6785 18.9496 10.6785 16.001V16.0006C10.6785 13.0519 8.28815 10.6616 5.33948 10.6616Z",
    fill: "url(#paint0_linear_10167_8820)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6261 10.6616H26.6257C23.677 10.6616 21.2866 13.0519 21.2866 16.0006V16.001C21.2866 18.9496 23.677 21.3399 26.6257 21.3399H26.6261C29.5748 21.3399 31.9651 18.9496 31.9651 16.001V16.0006C31.9651 13.0519 29.5748 10.6616 26.6261 10.6616Z",
    fill: "url(#paint1_linear_10167_8820)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.983 21.3218H15.9826C13.0339 21.3218 10.6436 23.7121 10.6436 26.6607V26.6611C10.6436 29.6098 13.0339 32.0001 15.9826 32.0001H15.983C18.9317 32.0001 21.3221 29.6098 21.3221 26.6611V26.6607C21.3221 23.7121 18.9317 21.3218 15.983 21.3218Z",
    fill: "url(#paint2_linear_10167_8820)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.983 0H15.9826C13.0339 0 10.6436 2.39032 10.6436 5.33893V5.33937C10.6436 8.28798 13.0339 10.6783 15.9826 10.6783H15.983C18.9317 10.6783 21.3221 8.28798 21.3221 5.33937V5.33893C21.3221 2.39032 18.9317 0 15.983 0Z",
    fill: "url(#paint3_linear_10167_8820)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1791 19.1018L18.3948 18.035C18.5191 17.9752 18.6094 17.8618 18.6399 17.7275L19.1873 15.33C19.2178 15.1957 19.186 15.0543 19.0996 14.9466L17.5665 13.0241C17.4806 12.9163 17.3502 12.8535 17.2124 12.8535H14.7533C14.6155 12.8535 14.4851 12.9163 14.3991 13.0241L12.866 14.9466C12.7801 15.0543 12.7478 15.1957 12.7784 15.33L13.3257 17.7275C13.3563 17.8618 13.4466 17.9752 13.5709 18.035L15.7866 19.1018C15.9109 19.1616 16.0552 19.1616 16.1791 19.1018Z",
    fill: "url(#paint4_linear_10167_8820)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10167_8820",
    x1: 0,
    y1: 16.0006,
    x2: 10.6781,
    y2: 16.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10167_8820",
    x1: 21.2866,
    y1: -7.55163,
    x2: 31.9647,
    y2: -7.55163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10167_8820",
    x1: 10.6436,
    y1: 26.6607,
    x2: 21.3216,
    y2: 26.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10167_8820",
    x1: 10.6436,
    y1: 5.33893,
    x2: 21.3216,
    y2: 5.33893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10167_8820",
    x1: 12.7666,
    y1: 15.9999,
    x2: 19.1982,
    y2: 15.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMartin);
export default __webpack_public_path__ + "static/media/icone-martin.386517f1cd9c85acf8383aed1715d787.svg";
export { ForwardRef as ReactComponent };